import ReplayIcon from '@mui/icons-material/Replay';
import { Autocomplete, Box, Button, Divider, TextField, Typography } from '@mui/material';
import * as EmailValidator from 'email-validator';
import { useEffect, useState } from 'react';
import { uid } from 'uid';
import { encrypt, loadContractorsIndex } from '../functions';

const VisitorDetails = ({
   customisations,
   clearForm,
   llid,
   goBack,
   form,
   contractor,
   setSelectedContractor,
   selectedContractor,
   ...props
}) => {
   const [name, setName] = useState(() => {
      if (form?.name !== undefined) {
         return form.name;
      }
      return '';
   });
   const [email, setEmail] = useState(() => {
      if (form?.email !== undefined) {
         return form.email;
      }
      return '';
   });
   const [inputValue, setInputValue] = useState(() => {
      if (form?.email !== undefined) {
         return form.email;
      }
      return '';
   });
   const [nameError, setNameError] = useState({ status: false, text: '' });
   const [emailError, setEmailError] = useState({ status: false, text: '' });
   const [contractorsLoaded, setContractorsLoaded] = useState(null);

   useEffect(() => {
      if (contractor && props.lid) {
         (async () => {
            const contractors = await loadContractorsIndex(props.lid);
            setContractorsLoaded(contractors);
         })();
      }
   }, [contractor, props.lid]);

   async function handleSubmit() {
      var valid = true;
      setNameError({ state: false, text: '' });
      setEmailError({ state: false, text: '' });
      var emailValid = EmailValidator.validate(email); // true
      if (emailValid === false) {
         setEmailError({ status: true, text: 'You must enter a vaild email address' });
         valid = false;
      }
      if (name === '') {
         setNameError({ status: true, text: 'You must enter a vaild email address' });
         valid = false;
      }
      if (valid) {
         props.setForm({ name, email: email.toLowerCase(), contractor });
         if (contractor && selectedContractor === null) {
            const emailEncrypted = await encrypt(email.toLowerCase());
            setSelectedContractor({
               uid: uid(15),
               email: emailEncrypted,
               name,
            });
         } else if (contractor && selectedContractor !== null) {
            const emailEncrypted = await encrypt(email.toLowerCase());
            setSelectedContractor({ ...selectedContractor, email: emailEncrypted });
         }
         props.setStatus('step2');
      }
   }

   return (
      <>
         <Typography variant="h5" component="h2">
            Your details
         </Typography>
         <Typography variant="body1" component="p" align="center">
            {contractor
               ? `If you are arriving or leaving, please enter your email address and name.`
               : `If you are arriving or leaving, please enter your name and email address.`}
         </Typography>
         <form
            style={{
               width: '100%',
               marginTop: 1,
            }}
         >
            <Box
               sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  gap: 3,
                  mb: 3,
                  justifyContent: 'space-between',
               }}
            >
               {llid && (
                  <Box sx={{ width: '15%', mt: 2 }}>
                     <Button
                        onClick={goBack}
                        sx={{ height: '130px' }}
                        fullWidth
                        variant="outlined"
                        color="primary"
                     >
                        Back
                     </Button>
                  </Box>
               )}
               <Box sx={{ minWidth: llid ? '70%' : '85%', flexDirection: 'column' }}>
                  {contractor && contractorsLoaded !== null && (
                     <Autocomplete
                        options={contractorsLoaded}
                        getOptionLabel={(option) => `${option.email}`}
                        filterOptions={(contractorsLoaded, { inputValue }) => {
                           if (inputValue.length < 3) {
                              return [];
                           }
                           return contractorsLoaded.filter(
                              (option) =>
                                 (typeof option.email === 'string' &&
                                    option.email
                                       .toLowerCase()
                                       .includes(inputValue.toLowerCase())) ||
                                 (typeof option.name === 'string' &&
                                    option.name
                                       .toLowerCase()
                                       .includes(inputValue.toLowerCase())),
                           );
                        }}
                        inputValue={inputValue}
                        onInputChange={(event, newInputValue) => {
                           setInputValue(newInputValue);
                           setEmail(newInputValue);
                        }}
                        renderInput={(params) => (
                           <TextField
                              {...params}
                              variant="outlined"
                              margin="normal"
                              required
                              fullWidth
                              id="email"
                              label="Email"
                              name="email"
                              value={inputValue}
                              error={emailError.status}
                              helperText={emailError.text}
                           />
                        )}
                        onChange={(event, newValue) => {
                           if (newValue) {
                              setEmail(newValue.email);
                              setName(newValue.name);
                              setInputValue(newValue.email);
                              setSelectedContractor({
                                 uid: newValue.uid,
                                 email: newValue.email,
                                 name: newValue.name,
                              });
                           } else {
                              setEmail(inputValue);
                              setName('');
                           }
                        }}
                        noOptionsText={
                           inputValue.length < 3
                              ? `Start typing to find your details (${
                                   3 - inputValue.length
                                } more characters)`
                              : 'No options'
                        }
                        fullWidth
                        freeSolo
                     />
                  )}

                  <TextField
                     variant="outlined"
                     margin="normal"
                     required
                     fullWidth
                     id="name"
                     label="Name"
                     name="name"
                     value={name}
                     error={nameError.status}
                     helperText={nameError.text}
                     onInput={(e) => setName(e.target.value)}
                  />
                  {!contractor && (
                     <TextField
                        variant="outlined"
                        margin="normal"
                        required
                        fullWidth
                        id="email"
                        label="Email Address"
                        name="email"
                        value={email}
                        onInput={(e) => {
                           setEmail(e.target.value);
                        }}
                        error={emailError.status}
                        helperText={emailError.text}
                     />
                  )}
               </Box>
               <Box
                  sx={{ width: '15%', mt: 2, display: 'flex', alignItems: 'flex-start' }}
               >
                  <Button
                     onClick={handleSubmit}
                     sx={{ height: '130px' }}
                     fullWidth
                     variant="contained"
                     color="primary"
                  >
                     Next
                  </Button>
               </Box>
            </Box>
            <Divider style={{ width: '100%' }} />
            <Box sx={{ width: '100%', mt: 2, display: 'flex', justifyContent: 'center' }}>
               <Button startIcon={<ReplayIcon />} onClick={clearForm} color="primary">
                  start again
               </Button>
            </Box>
         </form>
      </>
   );
};
export default VisitorDetails;
